import { FileObject } from "./FileObject";

export class InfoCenterFile extends FileObject {
  constructor() {
    super();
    this.InfoCenterFileID = "00000000-0000-0000-0000-000000000000";
    this.EnabledFor = "all";
    this.Active = true;
    this.Description = "";
    this.Category = -1;
    this.FileName = "";
    this.FullPath = "";
    this.FileType = "";
    this.Type = "upload";
    this.Index = 0;
  }

  public InfoCenterFileID: string;  
  public Index: number;
}
